import { OrgId, OrgWithStats } from 'shared/models';

export const Actions = {
    SET_ORGS_BUSY:  'SET_ORGS_BUSY',
    SET_ORGS:       'SET_ORGS',
    SET_ORGS_ERROR: 'SET_ORGS_ERROR',

    UPDATE_ORG: 'UPDATE_ORG',
};

export const setOrgsBusy = (busy: boolean = true) => ({
    type: Actions.SET_ORGS_BUSY,
    payload: busy,
});
export const setOrgs = (orgs: Record<OrgId, OrgWithStats>) => ({
    type: Actions.SET_ORGS,
    payload: orgs,
});
export const setOrgsError = (error: Error | null) => ({
    type: Actions.SET_ORGS_ERROR,
    payload: error,
    error: !!error,
});

export const updateOrg = (org: OrgWithStats) => ({
    type: Actions.UPDATE_ORG,
    payload: org,
});
